import React from "react";
import PageWrapper from "./content_library.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import ContentLibraryTable from "../../components/contentLibrary/ContentLibraryTable";
import UploadActions from "../../redux/fileUpload/actions";

const { failed, clear } = UploadActions;

const ContentLibrary = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.content_library"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.content_library"
          }
        ]}
      />
      <div className="user-tbl">
        <ContentLibraryTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.fileUpload,
    ...state.auth,
    ...state.permissionReducer
  };
};

export default connect(mapStateToProps, { failed, clear })(ContentLibrary);
